export const MEN_COLLECTIONS_ACTION_TYPES = {
  SORT_BY: 'SORT_BY',
  PAGE: 'PAGE',
  SORT_ORDER: 'SORT_ORDER',
  CLEAR: 'CLEAR',
  HANDLE_FILTERS_UI: 'HANDLE_FILTERS_UI',
  ADD_FILTERS: 'ADD_FILTERS',
  REMOVE_FILTERS: 'REMOVE_FILTERS',
  UPDATE_COLLECTION_ID: 'UPDATE_COLLECTION_ID',
  SET_FILTERS: 'SET_FILTERS',
}

const {
  SORT_BY,
  PAGE,
  SORT_ORDER,
  CLEAR,
  HANDLE_FILTERS_UI,
  // ADD_FILTERS,
  // REMOVE_FILTERS,
  UPDATE_COLLECTION_ID,
  SET_FILTERS,
} = MEN_COLLECTIONS_ACTION_TYPES

export interface menCollectionsActionInterface {
  type?: string
  payload?: object | any
}

export interface menCollectionsStateInterface {
  sortBy?: string
  currentPage?: string | number
  sortOrder?: string
  filters: any
}

export function menCollectionsReducer(
  state: menCollectionsStateInterface,
  { type, payload }: menCollectionsActionInterface
) {
  switch (type) {
    case UPDATE_COLLECTION_ID:
      return { ...state, collectionId: payload }
    case SORT_BY:
      return { ...state, sortBy: payload, currentPage: 1 }
    case PAGE:
      return { ...state, currentPage: payload }
    case SORT_ORDER:
      return { ...state, sortOrder: payload }
    case CLEAR:
      return { ...state, filters: [], currentPage: 1, sortBy: '' }
    case HANDLE_FILTERS_UI:
      return { ...state, areFiltersOpen: payload }
    case SET_FILTERS:
      return { ...state, filters: payload, currentPage: 1 }
    // case ADD_FILTERS:
    //   return { ...state, filters: [...state.filters, payload] }
    // case REMOVE_FILTERS:
    //   return {
    //     ...state,
    //     currentPage: 1,
    //     filters: state.filters.filter(
    //       (item: any) => item.Value !== payload.Value
    //     ),
    //   }
    default:
      return { ...state }
  }
}
